class paginationItem extends HTMLElement {
  constructor() {
    super();
    this.buttons = this.querySelectorAll('.pagination__item');
    this.buttons.forEach((button) =>
      button.addEventListener('click', this.onPaginateitemClick.bind(this))
    );
  }
  onPaginateitemClick(e) {
    e.preventDefault();
    window.updateURLHash({'page': e.target.dataset.pageIndex});
    location.href = window.location.href;
  }
}
customElements.define('pagination-content', paginationItem);
